module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-office-tour"
  }, [_c('TitleTrigger', {
    staticClass: "custom-office-tour__title-trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "custom-office-tour__container"
  }, [_c('div', {
    staticClass: "custom-office-tour__row"
  }, [_c('div', {
    staticClass: "custom-office-tour__col-left"
  }, [_c('div', {
    staticClass: "custom-office-tour__title",
    class: {
      active: this.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-office-tour__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  })]), _c('div', {
    staticClass: "custom-office-tour__col-right"
  }, [_c('iframe', {
    attrs: {
      "width": "853",
      "height": "480",
      "src": _vm.props.video,
      "frameborder": "0",
      "allowfullscreen": "",
      "allow": "vr"
    }
  })])]), _c('div', {
    staticClass: "custom-office-tour__collage"
  }, _vm._l((_vm.props.images), function(image, index) {
    return _c('div', {
      staticClass: "custom-office-tour__img",
      style: ({
        'background': 'url(' + image.image + ') no-repeat center / cover'
      }),
      attrs: {
        "id": 'img-' + index % 4
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b96fd3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-office-tour/custom-office-tour.pug
// module id = 634
// module chunks = 1